import type { ActivityType } from '../types';

type CapturedLocation = { latitude: number; longitude: number; locationAccuracy: number } | null;

/**
 * Whether to nudge the rep that location was not captured.
 * Only in-person visits matter for "were you at the school" accountability.
 */
export function shouldNudgeForMissingLocation(type: ActivityType, location: CapturedLocation): boolean {
  return type === 'IN_PERSON' && location == null;
}
